export const BASE_URL = "https://studentappserver.onrender.com";
// export const BASE_URL = "https://localhost:3001";
